// extracted by mini-css-extract-plugin
export default {"entityIcon":"BaseCompanyFieldCommon_entityIcon__nELq2"};